import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Form,
  FormGroup,
  Label,
  Input,
  Button,
  Col,
  Row,
  AlertProps,
} from "reactstrap";
import "../styles/ForgotPasswordStyle.css";
import RightSide from ".././.././../assets/images/RightSide.png"; // Include your image
import ".././.././../styles/CommonStyles.css";
import { validateEmailAddress } from "../../../utils/Validation";
import strings from "../../../utils/Strings";
import { useApi } from "../../../service/ApiContext";
import { forgotPasswordEmail } from "../data/api/ForgotPasswordApiCall";
import { logActionEvent } from "../../../analytics/analytics_utils";
import { useAlert } from "../../../components/AlertContextComponent";
import HttpService from "../../../service/HttpService";
import { ForgotPasswordRequest } from "../data/request/ForgotPasswordRequest";
import { ForgotPasswordResponse } from "../data/response/ForgotPasswordResponse";
import { NetworkResponse } from "../../../service/NetworkResponse";
import ForgotPasswordClient from "../data/api/ForgotPasswordApiClient";
import Loader from "../../../utils/Utils";
import analytics_strings from "../../../analytics/analytics_strings";

const ForgotPassword: React.FC = () => {
  const navigate = useNavigate();
  const [error, setError] = useState<string>("");
  const [email, setEmail] = useState<string>("");
  const [message, setMessage] = useState<string>("");
  const { showAlert } = useAlert();

  const api = useApi();

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setEmail(e.target.value);
    if (validateEmailAddress(e.target.value)) {
      setError("");
    } else {
      setError(strings.validation.emailError);
      setEmailRegError("");
    }
  };
  const forgotPasswordEmail = async (
    api: HttpService,
    email: string,
    showAlert: (props: Partial<AlertProps>) => void,
  ) => {
    const param: ForgotPasswordRequest = {
      email_address: email.trim().toLowerCase(), //(12-09-2025) Rana, Vivin, and Prashanth told me to send the email in lowercase.
      entity_type: "USER",
    };

    try {
      Loader.showLoading("Loading...");
      const response = await api
        .post<
          NetworkResponse<ForgotPasswordResponse>
        >(ForgotPasswordClient.forgotUrl, param)
        .then((response) => {
          if (response.data.detail != null) {
            navigate(strings.routing.resetLinkPage, { state: { emailOrUid } });

            // showAlert({
            //   show: true,
            //   title: "Success",
            //   message: response.data.detail,
            //   alertType: "success",
            //   onlyNeedOneButton: true,
            //   button1Text: "OK",
            // });
            return response.data;
          } else {
            setEmailRegError(response.data.error);
            // showAlert({
            //   show: true,
            //   title: "Error",
            //   message: response.data.error,
            //   alertType: "error",
            //   onlyNeedOneButton: true,
            //   button1Text: "OK",
            // });
          }
        });
    } catch (error) {
      throw error;
    } finally {
      Loader.dismissLoading();
    }
  };

  const handleSubmit = async () => {
    if (!emailOrUid.trim()) {
      setEmailError(
        selectedLoginType === "email"
          ? strings.validation.loginEmailError
          : strings.validation.uidError,
      );
      setEmailRegError("");
    } else {
      logActionEvent(analytics_strings.analytics_events.forgotButton, {
        emailId: emailOrUid,
      });
      if (emailError === "") {
        forgotPasswordEmail(api, emailOrUid, showAlert);
      }
    }
  };
  const [selectedLoginType, setSelectedLoginType] = useState<string>("email"); // Track login type
  const [emailOrUid, setEmailOrUid] = useState<string>(""); // Email or UID
  const [emailError, setEmailError] = useState<string>("");
  const [emailRegError, setEmailRegError] = useState<string>("");

  const [loginError, setLoginError] = useState<string>("");
  const handleRadioChange = (value: "email" | "uid") => {
    setSelectedLoginType(value);
    // Clear the email/UID and password fields when radio changes
    setEmailOrUid("");
    setEmailError("");
    setLoginError("");
    setEmailRegError("");
  };
  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setEmailOrUid(e.target.value);

    if (selectedLoginType === "email") {
      // Validate as email
      if (validateEmailAddress(e.target.value)) {
        setEmailError("");
        setEmailRegError("");
      } else {
        setEmailError(strings.validation.loginEmailError);
        setEmailRegError("");
      }
    } else {
      // Validate as UID
      if (!e.target.value.trim()) {
        setEmailError(strings.validation.uidError); // Show error if UID is empty
        setEmailRegError("");

        // } else if (validateUid(e.target.value)) {
        //   setEmailError("");
        // } else {
      } else {
        setEmailError(""); // Show error if UID is invalid
        setEmailRegError("");
      }
    }
  };

  return (
    // <div>
    //   <h1 className="heading">{strings.ForgotPassword.forgotPassword}</h1>
    //   <div className="checkbox-login-forgotpassword ">
    //     <Row>
    //       <Col>
    //         <FormGroup check className="custom-radio">
    //           <Input
    //             type="radio"
    //             name="flexRadioDefault"
    //             id="flexRadioDefault1"
    //             value="email"
    //             defaultChecked
    //             onChange={() => handleRadioChange("email")}
    //           />
    //           <Label
    //             style={{ fontSize: "14px", fontFamily: "mazzard" }}
    //             for="flexRadioDefault1"
    //             check
    //           >
    //             Email Id
    //           </Label>
    //         </FormGroup>
    //       </Col>
    //       <Col>
    //         <FormGroup check className="custom-radio">
    //           <Input
    //             type="radio"
    //             name="flexRadioDefault"
    //             id="flexRadioDefault2"
    //             value="uid"
    //             onChange={() => handleRadioChange("uid")}
    //           />
    //           <Label
    //             style={{ fontSize: "14px", fontFamily: "mazzard" }}
    //             for="flexRadioDefault2"
    //             check
    //           >
    //             UID
    //           </Label>
    //         </FormGroup>
    //       </Col>
    //     </Row>
    //   </div>
    //   <Form
    //     className="forgotpassword-form"
    //     onSubmit={(e) => {
    //       e.preventDefault();
    //       handleSubmit();
    //     }}
    //   >
    //     {/* <FormGroup>
    //       <Label for="email" style={{ color: "#666666" }}>
    //         {strings.ForgotPassword.enterMAil}
    //       </Label>
    //       <Input
    //         type="email"
    //         name="email"
    //         id="email"
    //         value={email}
    //         onChange={handleChange}
    //         className="form-control rounded-input"
    //       />
    //       {error && <div className="error-message">{error}</div>}
    //       {message && <div className="success-message">{message}</div>}
    //     </FormGroup> */}
    //     <FormGroup>
    //       <Label
    //         for="emailOrUid"
    //         style={{ color: "#666666", fontSize: "14px" }}
    //       >
    //         {selectedLoginType === "email" ? strings.login.emailLabel : "UID"}
    //       </Label>
    //       <Input
    //         value={emailOrUid}
    //         type="text"
    //         name="emailOrUid"
    //         id="emailOrUid"
    //         maxLength={50}
    //         onChange={handleInputChange}
    //         className={`form-control rounded-input ${
    //           emailError ? "input-error" : "form-control rounded-input"
    //         }`}
    //       />
    //       {emailError && (
    //         <div className="error-message" style={{ paddingTop: "5px" }}>
    //           {emailError}
    //         </div>
    //       )}
    //       <p className="subline-styling" style={{ paddingTop: "5" }}>
    //         {strings.ForgotPassword.resetText}
    //       </p>
    //       <div className="error-container">
    //         {emailRegError && (
    //           <div
    //             className="error-message"
    //             style={{ paddingTop: "8px", fontSize: "14px" }}
    //           >
    //             {emailRegError}
    //           </div>
    //         )}
    //       </div>
    //     </FormGroup>

    //     <center>
    //       <Button className="button" type="submit">
    //         {strings.ForgotPassword.continueBtnText}
    //       </Button>
    //     </center>
    //   </Form>
    //   <p className="backtologin-styling_p">
    //     <span className="backtologin-styling" onClick={() => navigate("/")}>
    //       {strings.ForgotPassword.backToLoginTxt}
    //     </span>
    //   </p>
    //   <div className="image-container1">
    //     <img src={RightSide} alt="logo" className="img-fluid bottom-image" />
    //   </div>
    // </div>
    <div className="v2-forget-wrapper">
      <h1 className="v2-forget-heading">
        {strings.ForgotPassword.forgotPassword}
      </h1>

      {/* LOGIN TYPE SWITCH */}
      <div className="v2-forget-radio-wrapper">
        <div
          className={`v2-forget-radio-option ${
            selectedLoginType === "email" ? "active" : ""
          }`}
        >
          <Input
            type="radio"
            name="flexRadioDefault"
            id="flexRadioDefault1"
            value="email"
            defaultChecked
            onChange={() => handleRadioChange("email")}
          />

          <Label for="flexRadioDefault1" check>
            Email ID
          </Label>
        </div>

        <div
          className={`v2-forget-radio-option ${
            selectedLoginType === "uid" ? "active" : ""
          }`}
        >
          <Input
            type="radio"
            name="flexRadioDefault"
            id="flexRadioDefault2"
            value="uid"
            onChange={() => handleRadioChange("uid")}
          />

          <Label for="flexRadioDefault2" check>
            UID
          </Label>
        </div>
      </div>

      {/* FORM */}
      <Form
        className="v2-forget-form"
        onSubmit={(e) => {
          e.preventDefault();
          handleSubmit();
        }}
      >
        <FormGroup className="v2-forget-form-group">
          <Label for="emailOrUid" className="v2-forget-label">
            {selectedLoginType === "email" ? strings.login.emailLabel : "UID"}
          </Label>

          <Input
            value={emailOrUid}
            type="text"
            name="emailOrUid"
            id="emailOrUid"
            maxLength={50}
            onChange={handleInputChange}
            className={`v2-forget-input ${
              emailError ? "v2-forget-input-error" : ""
            }`}
          />

          {emailError && <div className="v2-forget-error">{emailError}</div>}

          {emailRegError && (
            <div className="v2-forget-error-center">{emailRegError}</div>
          )}
        </FormGroup>
      </Form>

      {/* BACK TO LOGIN */}
      <p className="v2-forget-back-wrapper">
        <Button
          className={`v2-forget-button ${
            emailOrUid.trim() ? "v2-forget-button-active" : ""
          }`}
          onClick={handleSubmit}
        >
          {strings.ForgotPassword.continueBtnText}
        </Button>
        <span className="v2-forget-back-link" onClick={() => navigate("/")}>
          {strings.ForgotPassword.backToLoginTxt}
        </span>
      </p>
    </div>
  );
};

export default ForgotPassword;
